import { Cpu, MemoryStick } from 'lucide-react';
import { useHostStats } from '@/api/queries';
import { cn } from '@/lib/cn';
import { percent } from '@/lib/format';

export function HostPill() {
  const { data, isError } = useHostStats();
  if (isError || !data) {
    return (
      <div className="hidden gap-3 rounded-full border px-3 py-1 text-xs text-muted-foreground md:flex">
        host: offline
      </div>
    );
  }
  const memHot = data.mem.used_percent >= 90;
  return (
    <div
      className={cn(
        'hidden items-center gap-3 rounded-full border px-3 py-1 text-xs md:flex',
        memHot && 'animate-pulse-ring border-destructive text-destructive',
      )}
      title={`${data.hostname} · uptime ${(data.uptime_seconds / 3600).toFixed(1)} h`}
    >
      <span className="flex items-center gap-1">
        <Cpu className="h-3 w-3" /> {percent(data.cpu.usage_percent)}
      </span>
      <span className="flex items-center gap-1">
        <MemoryStick className="h-3 w-3" /> {percent(data.mem.used_percent)}
      </span>
    </div>
  );
}
